import { render, staticRenderFns } from "./DepTraditionalChineseMedicine.vue?vue&type=template&id=30a6f275&scoped=true&"
import script from "./DepTraditionalChineseMedicine.vue?vue&type=script&lang=js&"
export * from "./DepTraditionalChineseMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6f275",
  null
  
)

export default component.exports